/** 高强度密码：≥10 位，含大写/小写/数字/特殊字符 */
export const PASSWORD_MIN_LEN = 10
export const PASSWORD_HINT = '至少10位，须含大写、小写、数字和特殊字符'

export function validatePasswordStrength(password) {
  if (!password) return '密码不能为空'
  if (password.length < PASSWORD_MIN_LEN) return `密码长度至少 ${PASSWORD_MIN_LEN} 位`
  if (!/[A-Z]/.test(password)) return '密码需包含大写字母'
  if (!/[a-z]/.test(password)) return '密码需包含小写字母'
  if (!/[0-9]/.test(password)) return '密码需包含数字'
  if (!/[^A-Za-z0-9]/.test(password)) return '密码需包含特殊字符'
  return ''
}

export function passwordStrengthLevel(password) {
  if (!password) return 0
  let score = 0
  if (password.length >= PASSWORD_MIN_LEN) score += 1
  if (/[A-Z]/.test(password)) score += 1
  if (/[a-z]/.test(password)) score += 1
  if (/[0-9]/.test(password)) score += 1
  if (/[^A-Za-z0-9]/.test(password)) score += 1
  return score
}
